var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWindowSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 12h-6v-8h11v3h1v-7h-13v13h7zm4-11h1v1h-1zm-2 0h1v1h-1zm6 10.01-.2-.36v-.05c.45-1 .4-1.07.35-1.17l-.6-.56a.16992.16992 0 0 0 -.1-.05c-.05 0-.15 0-1 .41h-.05l-.4-.16v-.06c-.45-1-.5-1-.6-1h-.85c-.1 0-.15 0-.55 1.07v.05l-.35.1a6.45032 6.45032 0 0 0 -1-.41s-.1 0-.1.05l-.6.61c0 .1-.1.1.35 1.12v.05l-.2.36c-1 .41-1 .46-1 .56v.87c0 .1 0 .15 1 .56l.15.36v.05c-.45 1-.4 1.07-.35 1.17l.6.56a.17.17 0 0 0 .1.05 3.94523 3.94523 0 0 0 1-.41l.35.1v.05c.4 1.07.45 1.07.55 1.07h.85c.1 0 .15 0 .55-1.07v-.05l.35-.15h.05a6.45982 6.45982 0 0 0 1 .41c.05 0 .1 0 .1-.05l.6-.61c.1-.1.1-.1-.35-1.12v-.05l.15-.36h.2c1-.41 1-.46 1-.56v-.82c0-.1 0-.15-1-.56zm-3 2.51a1.5 1.5 0 1 1 .02007 0q-.01007.00006-.02007 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWindowSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/window-settings.2bf2f156ccc0f4abb71fa35aab6405ab.svg";